import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\ImpersonateController::exchange
* @see app/Http/Controllers/Api/ImpersonateController.php
* @route '/api/impersonate/exchange'
*/
export const exchange = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: exchange.url(options),
    method: 'post',
})

exchange.definition = {
    methods: ["post"],
    url: '/api/impersonate/exchange',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\ImpersonateController::exchange
* @see app/Http/Controllers/Api/ImpersonateController.php
* @route '/api/impersonate/exchange'
*/
exchange.url = (options?: RouteQueryOptions) => {
    return exchange.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\ImpersonateController::exchange
* @see app/Http/Controllers/Api/ImpersonateController.php
* @route '/api/impersonate/exchange'
*/
exchange.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: exchange.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\ImpersonateController::users
* @see app/Http/Controllers/Api/ImpersonateController.php
* @route '/api/impersonate/users'
*/
export const users = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: users.url(options),
    method: 'get',
})

users.definition = {
    methods: ["get","head"],
    url: '/api/impersonate/users',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\ImpersonateController::users
* @see app/Http/Controllers/Api/ImpersonateController.php
* @route '/api/impersonate/users'
*/
users.url = (options?: RouteQueryOptions) => {
    return users.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\ImpersonateController::users
* @see app/Http/Controllers/Api/ImpersonateController.php
* @route '/api/impersonate/users'
*/
users.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: users.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\ImpersonateController::users
* @see app/Http/Controllers/Api/ImpersonateController.php
* @route '/api/impersonate/users'
*/
users.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: users.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\ImpersonateController::switchMethod
* @see app/Http/Controllers/Api/ImpersonateController.php
* @route '/api/impersonate/switch/{user}'
*/
export const switchMethod = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: switchMethod.url(args, options),
    method: 'post',
})

switchMethod.definition = {
    methods: ["post"],
    url: '/api/impersonate/switch/{user}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\ImpersonateController::switchMethod
* @see app/Http/Controllers/Api/ImpersonateController.php
* @route '/api/impersonate/switch/{user}'
*/
switchMethod.url = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: args.user,
    }

    return switchMethod.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\ImpersonateController::switchMethod
* @see app/Http/Controllers/Api/ImpersonateController.php
* @route '/api/impersonate/switch/{user}'
*/
switchMethod.post = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: switchMethod.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\ImpersonateController::stop
* @see app/Http/Controllers/Api/ImpersonateController.php
* @route '/api/impersonate/stop'
*/
export const stop = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: stop.url(options),
    method: 'post',
})

stop.definition = {
    methods: ["post"],
    url: '/api/impersonate/stop',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\ImpersonateController::stop
* @see app/Http/Controllers/Api/ImpersonateController.php
* @route '/api/impersonate/stop'
*/
stop.url = (options?: RouteQueryOptions) => {
    return stop.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\ImpersonateController::stop
* @see app/Http/Controllers/Api/ImpersonateController.php
* @route '/api/impersonate/stop'
*/
stop.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: stop.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\ImpersonateController::start
* @see app/Http/Controllers/Api/ImpersonateController.php
* @route '/api/impersonate/start/{user}'
*/
export const start = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: start.url(args, options),
    method: 'post',
})

start.definition = {
    methods: ["post"],
    url: '/api/impersonate/start/{user}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\ImpersonateController::start
* @see app/Http/Controllers/Api/ImpersonateController.php
* @route '/api/impersonate/start/{user}'
*/
start.url = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: args.user,
    }

    return start.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\ImpersonateController::start
* @see app/Http/Controllers/Api/ImpersonateController.php
* @route '/api/impersonate/start/{user}'
*/
start.post = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: start.url(args, options),
    method: 'post',
})

const ImpersonateController = { exchange, users, switchMethod, stop, start, switch: switchMethod }

export default ImpersonateController